import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import mapboxgl from '!mapbox-gl';
import MapboxTraffic from '!@mapbox/mapbox-gl-traffic';
import 'mapbox-gl/dist/mapbox-gl.css';

import axios from 'axios';
import { baseUrl, baseUrlHub } from '../../../config';
import markerImg from '../../../image/custom_marker.png';
import warning from '../../../image/1718387763711.gif';
import { useSelector } from 'react-redux';
import { CardBody, CardHeader, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { arredondarParaCima } from '../../../utils';
import som from '../../../sound/sirene.mp3';

mapboxgl.accessToken =
  'pk.eyJ1IjoiYXhvbmFwaSIsImEiOiJjbGRudWE1dGowNHp3M3hudmJ4MTA2YjEwIn0.GkwFZHDIw2A3Le9BuyYa-A';

// Para o componente GeneralAlerts, adicione verificações de segurança:
const GeneralAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        setLoading(true);
        // Substitua pela sua URL de API real
        const response = await fetch(`${baseUrl}/alerts/general`);

        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        // Garanta que data seja um array
        setAlerts(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Erro ao buscar alertas:', err);
        setError(err.message);
        setAlerts([]); // Fallback para array vazio
      } finally {
        setLoading(false);
      }
    };

    fetchAlerts();
  }, []);

  if (loading) {
    return <div className="text-center">Carregando alertas...</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        Erro ao carregar alertas: {error}
      </div>
    );
  }

  // Verificação adicional de segurança antes do map
  if (!Array.isArray(alerts) || alerts.length === 0) {
    return <div className="alert alert-info">Nenhum alerta encontrado.</div>;
  }

  return (
    <div>
      {alerts.map((alert, index) => (
        <div key={alert.id || index} className="alert alert-warning">
          {/* Renderize o conteúdo do alerta aqui */}
          {alert.message || alert.title || 'Alerta sem conteúdo'}
        </div>
      ))}
    </div>
  );
};

export default GeneralAlerts;
